import React from 'react';
import Moment from 'moment';
import DateFilter from 'components/Grid/Filter/Date';

const columnConfig = [
  {
    title: 'clients.dateCreated',
    name: 'createdAt',
    accessor: row =>
      row.createdAt
        ? new Moment(row.createdAt).format(
            `${Moment.localeData().longDateFormat('L')} HH:mm:ss`
          )
        : '-',
    Filter: ({ onChange, filter }) => (
      <DateFilter onChange={onChange} value={filter?.value} />
    ),
    width: 120,
    filterable: false,
    sortable: false,
  },
  {
    title: 'clients.event',
    accessor: 'event',
    name: 'event',
    sortable: false,
  },
  {
    title: 'clients.points',
    accessor: 'value',
    name: 'value',
  },
  {
    title: 'clients.points.stateAfter',
    accessor: 'stateAfter',
    name: 'stateAfter',
    filterable: false,

    sortable: false,
  },
  {
    title: 'clients.moneybox.moderator',
    accessor: row =>
      `${row.moderator?.firstName ?? ''} ${row.moderator?.lastName ?? ''}`,
    name: 'moderator',
    filterable: false,
    sortable: false,
    maxWidth: 150,
  },
  {
    title: 'clients.moneybox.realModerator',
    accessor: row =>
      `${row.realModerator?.firstName ?? ''} ${
        row.realModerator?.lastName ?? ''
      }`,
    name: 'realModerator',
    filterable: false,
    sortable: false,
    maxWidth: 150,
  },
];

export default columnConfig;
